import { buildSplitIORequest } from '@/Components/FeatureToggle/UserSplitTreatments';
import { selectors } from '@/Store';
import { SplitContext, useTreatments } from '@splitsoftware/splitio-react';
import { isNil } from 'ramda';
import { useContext } from 'react';
import { useSelector } from 'react-redux';

export const useFeatureFlags = (featureNames: Array<string>) => {
  const user = useSelector(selectors.auth.user);
  const userAttributes = useSelector(selectors.userAttributes.attributes);
  const attributes = buildSplitIORequest(userAttributes, isNil(user));
  const splitContext = useContext(SplitContext);

  const { isReady } = splitContext;
  const treatments = useTreatments(featureNames, attributes);

  return { isReady, treatments };
};

/**
 * Do not use `!isOn` and `!isOff` as they might give incorrect values while `isReady = false`
 */
export const useFeatureFlag = (featureName: string) => {
  const { isReady, treatments } = useFeatureFlags([featureName]);
  const treatment = treatments[featureName]?.treatment;
  return {
    isReady,
    treatment,
    isOn: isReady && treatment === 'on',
    isOff: isReady && treatment === 'off',
  };
};

export const Flags = {
  PACKAGE_UPGRADE_JOURNEY: 'package-upgrade-journey-new',
  ENABLE_DIGITAL_AG_CONTROLS: 'enableDigitalAdControls',
};
